var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log } from "../../utils";
export class Sheet {
    constructor(page, listener) {
        this.page = page;
        this.listener = listener;
        this.enabled = false;
        this.unhook = () => { };
    }
    track() {
        try {
            this.untrack();
            const self = this;
            const proto = this.page.getWindow().CSSStyleSheet.prototype;
            const originals = {
                insertRule: proto.insertRule,
                deleteRule: proto.deleteRule,
                replace: proto.replace,
                replaceSync: proto.replaceSync,
            };
            proto.insertRule = function (rule, index = 0) {
                if (self.enabled) {
                    setTimeout(() => self.capture(this.ownerNode, "insertRule", rule, index), 0);
                }
                return originals.insertRule.call(this, rule, index);
            };
            proto.deleteRule = function (index) {
                if (self.enabled) {
                    setTimeout(() => self.capture(this.ownerNode, "deleteRule", "", index), 0);
                }
                originals.deleteRule.call(this, index);
            };
            proto.replace = function (text) {
                if (self.enabled) {
                    setTimeout(() => self.capture(this.ownerNode, "replace", text), 0);
                }
                return originals.replace.call(this, text);
            };
            proto.replaceSync = function (text) {
                if (self.enabled) {
                    setTimeout(() => self.capture(this.ownerNode, "replaceSync", text), 0);
                }
                return originals.replaceSync.call(this, text);
            };
            this.unhook = () => {
                this.unhook = () => { };
                proto.insertRule = originals.insertRule;
                proto.deleteRule = originals.deleteRule;
                proto.replace = originals.replace;
                proto.replaceSync = originals.replaceSync;
            };
            this.enabled = true;
        }
        catch (ex) {
            log(ex);
        }
    }
    untrack() {
        this.unhook();
        this.enabled = false;
    }
    dispatch(update) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = this.page.idp.getNode(update.target);
            if (target) {
                if (update.op === "deleteRule") {
                    target.sheet.deleteRule(update.index);
                }
                else {
                    yield target.sheet[update.op](update.css, update.index);
                }
            }
        });
    }
    capture(target, op, css, index = 0) {
        const targetId = this.page.idp.getId(target);
        if (targetId && target.isConnected) {
            this.listener({ target: targetId, op, css, index });
        }
    }
}
